import React, { useState, useEffect } from 'react'
import { Box, TextInput } from 'grommet'
import { Add, Image as ImageIcon } from 'grommet-icons'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { setChoices } from '../../redux/homepage/actions'
import { device } from '../../theme/device'
import TipDrop from '../Button/TipDrop'
import ImageUtil from '../../utils/imageUtil'
import { UploadInput as ImageInput } from '../Common'

const MainInputButton = styled.label`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.global.colors.primaryBg};
  /* border-radius: ${props => props.theme.button.border.radius}; */
  padding: 0rem 1.3rem;
  /* &:hover {
    box-shadow: 0px 0px 0px 2px
      ${props => props.theme.global.colors.primaryBg};
  } */
  /* @media ${device.medium} {
    padding: 0rem 1.5rem;
  } */
`

const WeightInput = styled.input`
  background-color: ${props => props.theme.global.colors.primaryBg};
  color: ${props => props.theme.global.colors.text};
  display: ${props => (props.weightOn ? 'flex' : 'none')};
  border: none;
  border-radius: 0px;
  width: 4rem;
  text-align: center;
  outline: none;
  margin-right: 0.5rem;
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
`

const MainInputData = styled(TextInput)`
  background-color: ${props => props.theme.global.colors.primaryBg};
  border: none;
  border-radius: 0px;
`

const ImageLabel = styled.label`
  /* border-radius: ${props => props.theme.button.border.radius}; */
  background-color: ${props => props.theme.global.colors.primaryBg};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0rem 0.8rem;
  &:has(:focus-visible) {
    background: ${props => props.theme.global.colors.hoverBg};
  }
`

const MainInput = () => {
  const [value, setValue] = useState('')
  const [weight, setWeight] = useState(1)
  const [newImages, setNewImages] = useState([])
  // const [imageInput, setImageInput] = useState(null)
  const choices = useSelector(state => state.main.choices)
  const weightOnPersist = useSelector(state => state.main.weightOn)
  const [weightOn, setWeightOn] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if (weightOnPersist !== weightOn) {
      setWeightOn(weightOnPersist)
    }
  }, [weightOnPersist])

  useEffect(() => {
    if (newImages.length > 0) {
      const timeOutId = setTimeout(() => {
        const appendedChoices = [...choices, ...newImages]
        dispatch(setChoices(appendedChoices))
        setNewImages([])
      }, 50)
      return () => clearTimeout(timeOutId)
    }
  }, [newImages])

  const clicked = input => {
    if (input === '') return
    let inputs = choices.slice(0)
    const data = { name: input, count: 0, filtered: false }
    if (weightOn && typeof weight === 'number' && weight > 1) {
      data['weight'] = weight
    }
    // if (type === 'image') {
    //   data['type'] = type
    // }
    inputs.push(data)
    dispatch(setChoices(inputs.slice(0)))
    setValue('')
    setWeight(1)
    // inputRef.current.focus()
  }

  const handleKeyPress = target => {
    if (target.charCode === 13) {
      clicked(value)
    }
  }

  const handleWeightChange = event => {
    let { value, min } = event.target
    if (value === '') {
      setWeight(value)
      return
    } else {
      value = Math.max(Number(min), Number(value))
      setWeight(value)
    }
  }

  const onImageChange = event => {
    if (event.target.files.length > 0) {
      for (const file of event.target.files) {
        // const file = event.target.files[0]
        const reader = new FileReader()
        reader.onload = async e => {
          const dataUri = await ImageUtil.optimizeSliceImage(e.target.result)
          const data = { name: value, count: 0, filtered: false, data: dataUri }
          if (weightOn && typeof weight === 'number' && weight > 1) {
            data['weight'] = weight
          }
          setNewImages(newImages => [...newImages, data])
        }
        reader.readAsDataURL(file)
      }
    }
    setValue('')
    setWeight(1)
  }

  return (
    <Box direction="row" gap=".7rem" margin={{ top: '1.2rem' }}>
      <Box direction="row" flex={true}>
        <WeightInput
          min="1"
          type="number"
          enterKeyHint="go"
          value={weight}
          onChange={handleWeightChange}
          onKeyPress={handleKeyPress}
          weightOn={weightOn}
        />
        <Box direction="row" flex={true}>
          <MainInputData
            id="MainInputText"
            type="text"
            enterKeyHint="go"
            placeholder="Input text here..."
            value={value}
            onChange={e => setValue(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <TipDrop content="Add Text / Press Enter" position="bottom">
            <MainInputButton
              tabIndex="-1"
              onClick={() => clicked(value)}
              htmlFor="MainInputText"
            >
              <Add color="text" />
            </MainInputButton>
          </TipDrop>
        </Box>
      </Box>

      <TipDrop content="Add Image(s)" position="bottom">
        <ImageLabel htmlFor="MainInputImage">
          <ImageIcon color="iconDarkLight" size="22px" />
          <ImageInput
            // tabIndex="-1"
            id="MainInputImage"
            onChange={onImageChange}
            onClick={event => {
              event.target.value = null
            }}
            type="file"
            accept="image/*"
            multiple="multiple"
          />
        </ImageLabel>
      </TipDrop>
    </Box>
  )
}

export default MainInput
